import React, { useContext, useState } from "react"
import { IntlContextConsumer, navigate } from "gatsby-plugin-intl"
import styled from 'styled-components'
import { colors, breakpoints } from '../utils/utils'
import { GlobalStateContext } from '../context/globalContext'
import { IoIosArrowDown } from 'react-icons/io'

export default (props) => {

  const state = useContext(GlobalStateContext)
  const [ selectOpen, setSelectOpen ] = useState(false)

  const languageName = {
    en: "EN",
    es: "ES",
  }

  const handleChangeLanguage = (e) => {
      setSelectOpen(!selectOpen)
      if(state.otherLanguageSlug) {
          if(e.target.value !== props.locale) {
            document.cookie = "nf_lang="+e.target.value
            navigate(`/${state.otherLanguageSlug}`)
          }
      }
  }

  const handleSelectClick = () => {
      setSelectOpen(!selectOpen)
  }

  const onBlurSelector = (e) => {
    const currentTarget = e.currentTarget
    setTimeout(() => {
        if (!currentTarget.contains(document.activeElement)) {
            setSelectOpen(false)
        }
      }, 0)
  }
  
  return(
    <>
        <Container onBlur={onBlurSelector}>
            <IntlContextConsumer>
            {
                ({ languages, language: currentLocale }) => (
                    <>
                        <CurrentLang selectOpen={selectOpen} onClick={handleSelectClick} className={selectOpen ? 'up' : 'down'}>
                            {languageName[currentLocale]}
                            <IoIosArrowDown className={selectOpen ? 'up' : 'down'}/>
                        </CurrentLang>
                        <LangList selectOpen={selectOpen}>
                            {
                                languages.map(lang => (
                                    (lang !== props.locale &&
                                        <li key={lang}>
                                            <button onClick={handleChangeLanguage} value={lang}>
                                                {languageName[lang]}
                                            </button>
                                        </li>
                                    )
                                ))
                            }
                        </LangList>
                    </>
                )
            }
            </IntlContextConsumer>
        </Container>
    </>
  )
}

const Container = styled.div`
    position: relative;
    button {
        padding: .15rem 0;
        background: none;
        border: 0;
        color: ${colors.quinary};
        cursor: pointer;
        min-height: 2rem;

        &:hover {
            border: 1px solid ${colors.quinary};
        }
    }
    > button {
        width: 3.3rem;
        ${breakpoints.md} {
            font-size: 1.4rem;
            width: 3.8rem;
        }
    }
`
const CurrentLang = styled.button`
    &.up {
        border-top: 1px solid ${colors.quinary};
        border-left: 1px solid ${colors.quinary};
        border-right: 1px solid ${colors.quinary};
        border-bottom: 0;
        background-color: ${colors.secondary};
    }
    svg {
        margin-left: .2rem;
        vertical-align: top;
        transition: transform .2s ease-in-out;
        &.up {
            transform: rotate(180deg);
        }
        &.down {
            transform: rotate(0);
        }
    }
`

const LangList = styled.ul`
    position: absolute;
    top: 100%;
    left: 0;
    padding: 0;
    margin: 0;
    display: ${ ({selectOpen}) => selectOpen ? 'block' : 'none'};
    li:not(:first-of-type) button{
        border-top: 0;
    }
    button {
        padding: .15rem 0;
        width: 3.3rem;
        border: 1px solid ${colors.quinary};
        background-color: ${colors.secondary};
        line-height: initial;
        ${breakpoints.md} {
            font-size: 1.4rem;
            width: 3.8rem;
            padding: .2rem 0;
        }
        svg {
            margin-left: .2rem;
            vertical-align: center;
        }
    }
`